<template>
	<div class="questions">

		<div class="questions-header">
			<div class="ask-public" v-if="me">
				<label for="toggle_ask-public" class="toggle-label">
					<div class="toggle">
						<input type="checkbox" id="toggle_ask-public" v-model="isPublic" :disabled="!me">
						<div class="toggle-line"></div>
						<div class="toggle-dot"></div>
					</div>
					<p>Ask Publicly</p>
				</label>
			</div>

			<div class="ask-question" v-if="me">
				<div class="ask-question-inner">
					<input :class="[{'error': error}]" type="text" v-model.trim="question_text" placeholder="Ask a question" @keyup="error=false" @keyup.enter="validateQuestion" :disabled="!me" required>
					<button class="btn btn-blue-light uppercase" @click="validateQuestion" aria-label="Post">
						<block-spinner :active="isLoading" size="5" color="text-white" class="absolute"></block-spinner>
						<span :class="[{'opacity-0':isLoading}]">Post</span>
						<svg class="arrow" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 30"><path d="M0 15l19.96-.002M10.322 6.02l8.98 8.981-8.982 8.982" stroke="#FFFFFF" stroke-width="3"></path></svg>
					</button>
				</div>
        <div class="ask-question-posted" v-if="messageSent && !error">
          <p>Your question has been sent to the hiring team. You'll get an email notification when they reply.</p>
        </div>
				<p class="error" v-if="error">{{ errorMessage }}</p>
			</div>
      <button v-if="!me" class="btn btn-blue-light uppercase" @click="doSignIn">Sign in to ask a question</button>

		</div>

		<div class="questions-cards" v-if="questions">
			<template v-for="(question,q) in questions" :key="q">
				<div class="questions-card" v-if="q < display_count">
          <div class="questions-card__header">
					  <p class="questions-card__date">{{ $filters.ukDate(question['Created Date']) }}</p>
            <p class="questions-card__public-private" v-if="question.public">- Public</p>
            <p class="questions-card__public-private" v-if="!question.public">- Private: Only you &amp; employer can see</p>
          </div>
					<p class="questions-card__question">{{ question['question'] }}</p>

					<div class="questions-card__answer" v-if="question.answered">
						<p class="questions-card__answer-title">Employers answer</p>

						<div class="questions-card__answer-employers-logo">
							<img :src="`/images/temp-employers-answer-logo.png?${$config.version}`" alt="Employers answer" loading="lazy">
						</div>
						<div class="questions-card__answer-response">
							<p>{{ question['answer'] }}</p>
						</div>

					</div>
				</div>
			</template>
		</div>

		<div class="btn-center" v-if="can_display_more">
			<button class="btn btn-blue-light uppercase btn-flex btn-centred" @click="loadMore">
				<block-spinner :active="isLoadMore" size="5" color="text-white" class="absolute"></block-spinner>
				<span :class="[{'opacity-0':isLoadMore}]">Load more</span>
			</button>
		</div>

	</div>
</template>

<script>
	import AuthMixins from '@/mixins/AuthMixins';

	export default {
		name: 'JobQuestions',
		mixins: [AuthMixins],
		props: {
			'job_id' : {
				'type': String
			}
		},

		data() {
			return {
				question_text: '',
				questions: false,
				isPublic: true,
				display_count: 2,
				isLoading: false,
				isLoadMore: false,
				error: false,
				errorMessage: '',
        messageSent: false
			}
		},

		mounted() {
			this.loadData();
		},

		methods: {
			loadData() {
				let payload = {
	  			'job_id': this.job_id,
	  			'user_id': (this.me) ? this.me.id : null
	  		}

	  		return this.$api.loadJobQuestions(payload).then(
	        (response) => {
	        	if (response.data.status == 'success') {
	        		this.questions = Object.values(response.data.response.questions);
              //let PublicQuestions = AllQuestions.filter(j => j.public);
              //this.questions = this.me ? AllQuestions : PublicQuestions;
              console.log('Questions', this.questions);
	        	}
	        }
	      ).catch((response) => {
	        console.log("Could not load saved jobs.", response);
	      });
			},
			validateQuestion() {
				this.error = false;
				if (this.question_text === '') {
					this.error = true;
					this.errorMessage = 'The question field is required.'
				} else {
					this.error = false;
					this.errorMessage = ''
					this.postQuestion();
				}
			},
			postQuestion() {
				this.isLoading = true;

				if (this.me) {
					let payload = {
		  			'job_id': this.job_id,
		  			'question': this.question_text,
		  			'public': this.isPublic
		  		}

					this.emitter.emit('gaEventTrack',  {'category':'job', 'action':'post-question', 'label':this.job_id});

		  		return this.$api.askQuestion(payload).then(
		        (response) => {
		        	if (response.data.status == 'success') {
		        		this.questions = response.data.response.questions;
		        		this.question_text = '';
                this.messageSent = true;
                setTimeout(() => {
                  this.messageSent = false;
                }, 6000);
                this.emitter.emit('toast', {message:'Question sent successfully', type:'success'});
		        	}
							this.isLoading = false;
		        }
		      ).catch((response) => {
		        console.log("Could not ask question job.", response);
		      });
		    } else {
		    	alert('You must be logged in.');
		    }
			},
			loadMore() {
				this.isLoadMore = true;
				this.display_count +=2;
				setTimeout(() => {
					this.isLoadMore = false;
				}, 600);
				this.emitter.emit('gaEventTrack',  {'category':'job', 'action':'load-more-questions', 'label':this.job_id});
			},
      doSignIn() {
        this.emitter.emit("openModal", { name: 'SignIn', persistent: false });
      }
		},

		computed: {
			can_display_more() {
				if (this.questions) {
					if (this.display_count < this.questions.length) {
						return true;
					}
				}
				return false;
			}
		}
	}
</script>
